export default __webpack_public_path__ + "static/media/274.efb19192.png";